import * as React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { CompositeProductInfoState } from './CompositeProductInfoState';
import classNames from 'classnames';
import { useCompositeProductSelfTranslation } from '@/localization/useProjectLabelTranslation';

interface CompositeProductInfoUIElementProps {
  state: CompositeProductInfoState;
}

export const CompositeProductInfoUIElement = observer(function CompositeProductInfoUIElement({
  state,
}: CompositeProductInfoUIElementProps) {
  const { t: _tTranslation } = useTranslation('translation');
  const viewElement = state.viewElement;
  const productTypeKey = state.api?.getProduct?.()?.productType?.productTypeKey;
  const productKey = state.productData?.productKey;
  const tProductType = useCompositeProductSelfTranslation(productTypeKey);

  return (
    <div className={'cp-composite-product-info'} data-element-id={viewElement.id}>
      {viewElement.showTitle && state.title && (
        <h3 data-main-title className={classNames('cp-composite-product-info__title')}>
          {tProductType.name(productKey, state.title)}
        </h3>
      )}
      {viewElement.showShortDescription && state.shortDescription && (
        <div className={'cp-composite-product-info__short-description'}>{state.shortDescription}</div>
      )}

      {viewElement.showDescription && state.description && (
        <div className={'cp-composite-product-info__description'}>
          {tProductType.description(productKey, state.description)}
        </div>
      )}
    </div>
  );
});
